import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChevronDownSystemIcon from "@nib/icons/system/ChevronDown";
import CloseSystemIcon from "@nib/icons/system/Close";
import ExternalLinkSystemIcon from "@nib/icons/system/ExternalLink";
import isFunction from "lodash.isfunction";
import { dontBubble } from "@nib-group/chatbot-shared/global-utils";
import { VisuallyHidden } from "@nib-group/chatbot-shared/components";
import * as S from "./Toolbar.style";
import CONTENT from "./Toolbar.content";
export const MINIMISE_TEST_ID = "MinimiseButton__TestId";
const Toolbar = _ref => {
  let {
    isMinimised,
    unreadMessages = 0,
    statusText,
    StatusIconComponent = null,
    onToggleClick,
    onPopoutClick,
    onCloseClick,
    toggleControlId
  } = _ref;
  return _jsxs(S.Wrapper, {
    onClick: onToggleClick,
    children: [_jsxs(S.StatusContainer, {
      children: [unreadMessages > 0 && _jsxs(S.UnseenMessageBadge, {
        tabIndex: 0,
        title: CONTENT.UNREAD_MESSAGES_TITLE,
        children: [unreadMessages, _jsx(VisuallyHidden, {
          text: CONTENT.UNREAD_MESSAGES_VH_SUFFIX
        })]
      }), StatusIconComponent !== null && _jsx(StatusIconComponent, {}), statusText]
    }), _jsxs(S.ButtonContainer, {
      children: [isFunction(onPopoutClick) && _jsx(S.ToolbarButton, {
        type: "button",
        onClick: dontBubble(onPopoutClick),
        title: CONTENT.POPOUT_BUTTON,
        children: _jsx(ExternalLinkSystemIcon, {
          size: 14
        })
      }), typeof isMinimised === "boolean" && isFunction(onToggleClick) && _jsx(S.ToolbarButton, {
        type: "button",
        onClick: dontBubble(onToggleClick),
        "data-testid": MINIMISE_TEST_ID,
        "aria-expanded": !isMinimised,
        "aria-controls": toggleControlId,
        title: isMinimised ? CONTENT.TOGGLE_MINIMISED.CLOSED : CONTENT.TOGGLE_MINIMISED.OPEN,
        children: _jsx(S.FlipIcon, {
          shouldFlip: !!isMinimised,
          children: _jsx(ChevronDownSystemIcon, {
            size: "xs"
          })
        })
      }), isFunction(onCloseClick) && _jsx(S.ToolbarButton, {
        type: "button",
        onClick: dontBubble(onCloseClick),
        title: CONTENT.CLOSE_BUTTON,
        children: _jsx(CloseSystemIcon, {
          size: 12
        })
      })]
    })]
  });
};
export default Toolbar;
export * as Styles from "./Toolbar.style";